import { createContext, useContext } from 'react';
import { Org } from '@cotera/api';

/**
 * Context that provides the current org when inside an org route.
 * Returns undefined when outside of an org context.
 */
const CurrentOrgContext = createContext<Org | undefined>(undefined);

export const CurrentOrgProvider = CurrentOrgContext.Provider;

/**
 * Hook to get the current org. Returns undefined if not in an org context.
 */
export const useCurrentOrg = () => useContext(CurrentOrgContext);
